import React, { Component } from 'react';
import { Link } from '@xo-union/tk-component-buttons';

export default class LinkAgent extends Component {
  static defaultProps = {
    size: 'md',
    color: 'secondary',
    active: false,
    href: 'javascript:void(0)',
    trackingData: {},
    linkText: '',
    dataClear: false,
    id: null,
    classes: '',
    disabled: null,
    dataApply: false,
    dataSpinnable: false,
    rel: '',
    target: null
  };

  render() {
    const { ariaLabel, size, color, href, trackingData, linkText, dataClear, active, id, classes, disabled, dataApply, dataSpinnable, rel, target, iconName, ...passThroughProps } = this.props;
     return(
      <Link id={id}
            size={size}
            aria-label={ariaLabel}
            color={ active ? 'primary' :  color }
            href={href}
            data-params={ JSON.stringify(trackingData) }
            data-clear={ dataClear ? 'true' : null }
            className={ classes }
            disabled={ disabled }
            data-apply= { dataApply ? "true" : null }
            data-spinnable= { dataSpinnable ? 'true' : null }
            data-track-results-viewed-event={ trackingData['track-results-viewed-event'] }
            data-track-results-viewed-results-type={ trackingData['track-results-viewed-results-type'] }
            data-track-results-viewed-page-count={ trackingData['track-results-viewed-page-count'] }
            data-track-results-viewed-selected={ trackingData['track-results-viewed-selected'] }
            rel={rel}
            target={target}
            onClick={this.props.onClick}
            iconName={iconName}
            { ...passThroughProps }>{linkText}</Link>
    )
  }
}
